import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconLockOpenFill';
/** Renders an SVG icon. */
const SvgLockOpenFill = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.859 4.725a7 7 0 0 1 8.005-3.435l.28.076a7 7 0 0 1 4.799 8.967L22.387 12H24a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v-8a4 4 0 0 1 4-4h12.28l.766-2.3a5 5 0 0 0-3.428-6.404l-.28-.077a5 5 0 0 0-5.718 2.454l-1.24 2.301a1 1 0 0 1-1.76-.948zm7.348 12.068a1.707 1.707 0 0 0-2.414 2.414l.207.207V22a1 1 0 1 0 2 0v-2.586l.207-.207a1.707 1.707 0 0 0 0-2.414"
      />
    </svg>
  );
};
SvgLockOpenFill.displayName = displayName;
export default SvgLockOpenFill;
